export const researchPlatforms = [
  {
    id: 'saint',
    name: 'SAInt',
    category: 'Integrated energy systems simulation',
    description: 'Electricity, gas, and coupled energy-network modeling for infrastructure resilience, scenario analysis, and operational studies.',
    url: 'https://docs.encoord.com/welcome/index.html',
  },
  {
    id: 'cooja',
    name: 'Cooja / Contiki-NG',
    category: 'Low-power IoT network simulation',
    description: 'RPL-based IoT experimentation, multi-attack simulation, routing analysis, and evaluation of network behavior and overhead.',
    url: 'https://docs.contiki-ng.org/en/master/doc/tutorials/Running-Contiki-NG-in-Cooja.html',
  },
  {
    id: 'ccast',
    name: 'NDSU CCAST',
    category: 'High-performance computing',
    description: 'Large-scale computation, model training, scientific simulation, and reproducible research workflows on NDSU HPC infrastructure.',
    url: 'https://www.ndsu.edu/ccast',
  },
  {
    id: 'matlab',
    name: 'MATLAB',
    category: 'Engineering modeling & analysis',
    description: 'Numerical computing, algorithm prototyping, data analysis, and simulation for energy and networked-system research.',
    url: 'https://www.mathworks.com/products/matlab.html',
  },
];

const skillsConfig = [
  {
    id: 'ai',
    title: 'Machine Learning & AI',
    description: 'Models and frameworks',
    skills: ['Graph Neural Networks', 'GCN', 'GAT', 'GraphSAGE', 'Deep Learning', 'Reinforcement Learning', 'Explainable AI', 'PyTorch', 'TensorFlow', 'Keras', 'scikit-learn'],
  },
  {
    id: 'network',
    title: 'Network Science & Energy',
    description: 'Research specialisms',
    skills: ['Multilayer Networks', 'Complex Systems', 'Link Prediction', 'Network Resilience', 'Power Grids', 'Predictive Maintenance', 'Vulnerability Assessment', 'Integrated Gas-Electric Networks'],
  },
  {
    id: 'programming',
    title: 'Programming & Data',
    description: 'Languages and analysis',
    skills: ['Python', 'R', 'SQL', 'MATLAB', 'C++', 'Pandas', 'NumPy', 'NetworkX', 'Matplotlib', 'Seaborn', 'Plotly'],
  },
  {
    id: 'simulation',
    title: 'Simulation & Research Computing',
    description: 'Specialized platforms and computational workflows',
    skills: ['SAInt', 'Cooja', 'Contiki-NG', 'MATLAB', 'NDSU CCAST', 'High-Performance Computing', 'IoT Network Simulation', 'Large-Scale Scientific Computing'],
  },
  {
    id: 'systems',
    title: 'Systems & Engineering',
    description: 'Platforms and delivery',
    skills: ['Git', 'Docker', 'Linux', 'Jupyter', 'LaTeX', 'Oracle', 'MySQL', 'PostgreSQL', 'JavaScript', 'PHP', 'CodeIgniter', 'AngularJS'],
  },
  {
    id: 'domains',
    title: 'Applied Research Domains',
    description: 'Cross-disciplinary work',
    skills: ['Smart Energy Systems', 'Critical Infrastructure', 'Internet of Things', 'Wireless Networks', 'Cybersecurity', 'Digital Forensics', 'Biomedical AI', 'Reverse Vaccinology', 'Protein Networks'],
  },
];

export default skillsConfig;
